import { render, staticRenderFns } from "./InstructorClass.vue?vue&type=template&id=c7912a50&scoped=true&"
import script from "./InstructorClass.js?vue&type=script&lang=js&"
export * from "./InstructorClass.js?vue&type=script&lang=js&"
import style0 from "./InstructorClass.vue?vue&type=style&index=0&id=c7912a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7912a50",
  null
  
)

export default component.exports